import React from 'react';
import { Link } from 'react-router-dom';

function Home() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-900 to-blue-700 text-white flex items-center justify-center flex-col p-6 fade-in">
  <div className="text-center">
    <h1 className="text-5xl font-bold text-orange-500 mb-2">SopoTec</h1>
    <h2 className="text-2xl mb-4">Soporte Técnico Profesional</h2>
    <p className="text-xl italic mb-6">¡Tu Solución tecnológica!</p>
    <p className="text-lg max-w-lg text-center mb-6">
      Soluciones innovadoras en reparación, redes, bases de datos y desarrollo.
    </p>
    <Link to="/services" className="mt-6 bg-orange-500 text-white px-6 py-3 rounded-lg hover:bg-orange-600 transition-colors duration-300 font-semibold">
      Explora Mis Servicios
    </Link>
  </div>
</div>
  );
}

export default Home;